import { HStack } from "native-base";
import React from "react";
import { StyleSheet, View } from "react-native";
import Theme from "../argon-ui/Theme";
import Text from "./TextFont";

type Props = {
  label: string;
};

const DividerWithText = (props: Props) => {
  return (
    <HStack space="2" my="4" alignItems="center">
      <View style={styles.divider} />
      {props.label && (
        <Text style={{ fontSize: 11, color: Theme.COLORS.MUTED }}>
          {props.label}
        </Text>
      )}
      <View style={styles.divider} />
    </HStack>
  );
};
const styles = StyleSheet.create({
  divider: {
    height: 1,
    backgroundColor: Theme.COLORS.BLOCK,
    flex: 1,
    borderRadius: 5,
  },
});
export default DividerWithText;
